import { useProject as useProjectQuery } from "../../../../hooks/query";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Box, Divider } from "@mui/joy";
import { BriefcaseBusiness, CalendarDays, FileStack, Settings, SquareLibrary, FileText } from "lucide-react";

import { useProject } from "../../../../hooks";
import { SummaryCard } from "./SummaryCard";
import { ListTask } from "../../../Tasks";
import { Overview, Settings as SettingsCmt, Documentation } from "./components";
import { NavigationTabs } from "./NavigationTabs";
import { Timeline } from "./Timeline";
import { Notes } from "./Notes";
import { MapHero } from "./MapHero";

export default function ProjectDetails() {
    const { setProject } = useProject();
    const params = useParams();
    const id = params.id as string;

    const { useListById } = useProjectQuery();
    const listProjectByIdSvc = useListById();

    const tabList = [
        {
            name: "Tasks",
            icon: <BriefcaseBusiness size={18} />,
            component: <ListTask />,
        },
        {
            name: "Overview",
            icon: <SquareLibrary size={18} />,
            component: <Overview />,
        },

        {
            name: "Documents",
            icon: <FileStack size={18} />,
            component: <Documentation />,
        },
        {
            name: "Manage",
            icon: <Settings size={18} />,
            component: <SettingsCmt />,
        },
        {
            name: "Timeline",
            icon: <CalendarDays size={18} />,
            component: <Timeline />,
        },
    ];

    useEffect(() => {
        if (id) {
            setProject({ id });
        }
    }, [id]);

    return (
        <Box flex={1} display={"flex"} overflow={"auto"} sx={{ flexDirection: { xs: "column", md: "row" } }}>
            <Box
                flex={1}
                display={"flex"}
                flexDirection={"column"}
                position={"relative"}
                sx={{ minWidth: 0, minHeight: 0 }}
            >
                {/* Map hero background behind SummaryCard */}
                <MapHero />
                <Box my={2} mx={2} sx={{ position: "relative", zIndex: 2 }}>
                    <SummaryCard />
                </Box>
                <Divider />
                <Box sx={{ flex: 1, minHeight: 0 }}>
                    <NavigationTabs tabList={tabList} loading={listProjectByIdSvc.isPending} />
                </Box>
            </Box>

            <Notes />
        </Box>
    );
}
